import _regeneratorRuntime from "@babel/runtime-corejs2/regenerator";
import _asyncToGenerator from "@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import _Promise from "@babel/runtime-corejs2/core-js/promise";
import _classCallCheck from "@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _assertThisInitialized from "@babel/runtime-corejs2/helpers/esm/assertThisInitialized";
import _createClass from "@babel/runtime-corejs2/helpers/esm/createClass";
import _inherits from "@babel/runtime-corejs2/helpers/esm/inherits";
import _createSuper from "@babel/runtime-corejs2/helpers/esm/createSuper";
import _defineProperty from "@babel/runtime-corejs2/helpers/esm/defineProperty";
import { WebLoginPreferencesInterface } from '@central-products/interface-web-login-preferences';
import { createCasClient } from '@central-products/cas-client';
import { errors } from './errors';
import { createErrorWithoutState } from './utils';
var TWO_SECONDS = 2000;
export var WebLoginPreferences = /*#__PURE__*/function (_WebLoginPreferencesI) {
  _inherits(WebLoginPreferences, _WebLoginPreferencesI);

  var _super = _createSuper(WebLoginPreferences);

  _createClass(WebLoginPreferences, [{
    key: "KeepLoggedIn",
    get: function get() {
      return this.keepLoggedIn;
    }
  }, {
    key: "RememberUsername",
    get: function get() {
      return this.rememberUsername;
    }
  }]);

  function WebLoginPreferences(_ref) {
    var _this;

    var casUrl = _ref.casUrl,
        serviceUrl = _ref.serviceUrl,
        _ref$enableFlagHandli = _ref.enableFlagHandling,
        enableFlagHandling = _ref$enableFlagHandli === void 0 ? false : _ref$enableFlagHandli,
        _ref$enableRecaptcha = _ref.enableRecaptcha,
        enableRecaptcha = _ref$enableRecaptcha === void 0 ? false : _ref$enableRecaptcha,
        _ref$enableSessionRen = _ref.enableSessionRenew,
        enableSessionRenew = _ref$enableSessionRen === void 0 ? false : _ref$enableSessionRen;

    _classCallCheck(this, WebLoginPreferences);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "keepLoggedIn", false);

    _defineProperty(_assertThisInitialized(_this), "rememberUsername", void 0);

    _defineProperty(_assertThisInitialized(_this), "isPreferencesSet", false);

    _defineProperty(_assertThisInitialized(_this), "casClient", void 0);

    _defineProperty(_assertThisInitialized(_this), "retryTimeout", void 0);

    _defineProperty(_assertThisInitialized(_this), "enableSessionRenew", false);

    _defineProperty(_assertThisInitialized(_this), "retryInterval", void 0);

    _defineProperty(_assertThisInitialized(_this), "retry", function () {
      return new _Promise(function (resolve) {
        _this.retryTimeout = window.setTimeout(function () {
          _this.retryTimeout = null;

          _this.callIamAlive().then(resolve);
        }, _this.retryInterval);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "clearRetryTimer", function () {
      if (_this.retryTimeout) {
        window.clearInterval(_this.retryTimeout);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "callIamAlive", function () {
      return new _Promise(function (resolve) {
        _this.casClient.imAlive().then(function (_ref2) {
          var imAlive = _ref2.imAlive;

          _this.clearRetryTimer();

          resolve(imAlive);
        }).catch(function (_ref3) {
          var status = _ref3.status;

          if (!status) {
            _this.retry().then(resolve);
          } else {
            _this.clearRetryTimer();

            resolve(false);
          }
        });
      });
    });

    _this.enableSessionRenew = enableSessionRenew;
    _this.casClient = createCasClient({
      casUrl: casUrl,
      serviceUrl: serviceUrl,
      enableFlagHandling: enableFlagHandling,
      enableRecaptcha: enableRecaptcha
    });
    _this.retryInterval = TWO_SECONDS;
    return _this;
  }

  _createClass(WebLoginPreferences, [{
    key: "get",
    value: function () {
      var _get = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var isLoggedIn, response, preferences, _response$form_defaul, keepMeLoggedIn, username, rememberUsername;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(this.enableSessionRenew === false)) {
                  _context.next = 6;
                  break;
                }

                _context.next = 3;
                return this.callIamAlive().then(function (r) {
                  return r;
                }).catch(function () {
                  return false;
                });

              case 3:
                isLoggedIn = _context.sent;

                if (!isLoggedIn) {
                  _context.next = 6;
                  break;
                }

                return _context.abrupt("return", _Promise.reject(createErrorWithoutState(errors.WebLoginPreferences.get.stateInvalid)));

              case 6:
                _context.prev = 6;
                _context.next = 9;
                return this.casClient.getFormDefaults({
                  renew: this.enableSessionRenew
                });

              case 9:
                response = _context.sent;

                if (!this.isPreferencesSet) {
                  _context.next = 14;
                  break;
                }

                preferences = this.getPreferences();
                this.resetPreferences();
                return _context.abrupt("return", preferences);

              case 14:
                _response$form_defaul = response.form_defaults, keepMeLoggedIn = _response$form_defaul.keepMeLoggedIn, username = _response$form_defaul.username, rememberUsername = _response$form_defaul.rememberUsername;
                this.keepLoggedIn = keepMeLoggedIn;

                if (rememberUsername && username) {
                  this.rememberUsername = {
                    username: username
                  };
                }

                _context.next = 22;
                break;

              case 19:
                _context.prev = 19;
                _context.t0 = _context["catch"](6);
                return _context.abrupt("return", _Promise.reject(createErrorWithoutState(errors.WebLoginPreferences.get.operationFailed)));

              case 22:
                return _context.abrupt("return", this.getPreferences());

              case 23:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[6, 19]]);
      }));

      function get() {
        return _get.apply(this, arguments);
      }

      return get;
    }()
  }, {
    key: "set",
    value: function () {
      var _set = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(data) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.keepLoggedIn = data.keepLoggedIn;
                this.rememberUsername = data.rememberUsername;
                this.isPreferencesSet = true;
                return _context2.abrupt("return", {});

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function set(_x) {
        return _set.apply(this, arguments);
      }

      return set;
    }()
  }, {
    key: "getPreferences",
    value: function () {
      var _getPreferences = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", {
                  keepLoggedIn: this.keepLoggedIn,
                  rememberUsername: this.rememberUsername
                });

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getPreferences() {
        return _getPreferences.apply(this, arguments);
      }

      return getPreferences;
    }()
  }, {
    key: "resetPreferences",
    value: function resetPreferences() {
      this.isPreferencesSet = false;
      this.keepLoggedIn = false;
      this.rememberUsername = undefined;
    }
  }]);

  return WebLoginPreferences;
}(WebLoginPreferencesInterface);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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